export default "clipboardCatcher";